import React from 'react'

export const AutoDetail = ({name, model, price, img, id}) => {
    console.log('price', price)
    return (
        <div className="autoDetail">
            <h1 className="title20">{name}</h1>
            <h2 className="ff-FuturaBold">{model}</h2>
            <span>
            </span>
            <img src={`/storage/modelos/${id}/${img}`}/>
            <h2 className="ff-FuturaMedium">CUOTA DESDE</h2>
            <h1 className="ff-FuturaBold">${price}</h1>
        </div>
    )
}
